import { useEffect } from "react";

/**
 * Where Google redirects the consent popup back to.
 *
 * This page runs *inside the popup*. It does nothing but hand the code to the
 * window that opened it and close — the exchange itself happens in the opener,
 * which holds the session, and then on the API, which holds the client secret.
 * The code never touches this component beyond being passed along.
 *
 * It is a route on our own origin rather than a direct redirect to the API, so
 * the `postMessage` origin check in `connectors-api.ts` has something to match
 * and the wizard keeps its unsaved state in the original tab.
 */
export function GoogleDriveCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      source: "gb-google-drive" as const,
      code: params.get("code") ?? undefined,
      state: params.get("state") ?? undefined,
      error: params.get("error") ?? undefined,
    };

    // Targeted at our own origin, never "*": a wildcard would broadcast the
    // authorisation code to whatever page happened to be listening.
    window.opener?.postMessage(payload, window.location.origin);
    window.close();
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-canvas px-6 text-center">
      <p className="font-display text-[0.8rem] uppercase tracking-[0.1em] text-muted">
        Finishing Google sign-in — you can close this window.
      </p>
    </div>
  );
}
